import React, { useState, useMemo } from 'react';
import { Select } from 'antd';
import { getData } from 'country-list';
import PropTypes from 'prop-types';

// Helper: convert ISO2 -> flag emoji
const getFlagEmoji = (countryCode) => {
  if (!countryCode) return '';
  return countryCode
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt()));
};

const CountryDropDown = ({
  value,
  onChange,
  placeholder = 'Type or select a country...',
  style = { width: '100%' },
  allowClear = true,
  showSearch = true,
  ...restProps
}) => {
  const countryData = getData();

  // Prepare dropdown options with flag, name, and code
  const options = useMemo(() => {
    return countryData.map((country) => ({
      label: (
        <span>
          {getFlagEmoji(country.code)} {country.name}
        </span>
      ),
      value: country.code,
      searchName: country.name // Add searchable name for filtering
    }));
  }, []);

  const handleChange = (selectedValue) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  const filterOption = (input, option) => {
    if (!input) return true;
    const searchText = input.toLowerCase();
    return option.searchName.toLowerCase().includes(searchText);
  };

  return (
    <Select
      value={value}
      placeholder={placeholder}
      style={style}
      onChange={handleChange}
      options={options}
      showSearch={showSearch}
      allowClear={allowClear}
      filterOption={filterOption}
      listHeight={256}
      getPopupContainer={(trigger) => trigger.parentNode}
      {...restProps}
    />
  );
};

CountryDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  allowClear: PropTypes.bool,
  showSearch: PropTypes.bool
};

export default CountryDropDown;
